<template>
  <div class="container">
    <div class="myEchart" style="width: 60%; height: 900px; margin-top: 30px">
      <p>Choose a spot in the ocean for your drilling project.</p>
      <span style="margin-top: 30px; font-size: large; margin-right: 20px">
        latitude: {{ Math.floor(currentPoint[1]) }}
      </span>
      <span style="margin-top: 30px; font-size: large">
        longitude: {{ Math.floor(currentPoint[0]) }}
      </span>
      <div>latitude:<a-input v-model="currentPoint[1]" /></div>
      <div>longitude:<a-input v-model="currentPoint[0]" /></div>
      <a-button style="margin-top: 10px" @click="getData">search</a-button>
      <div ref="myEchart" style="height: 800px; margin-top: 30px"></div>
    </div>
    search
    <div style="width: 40%; height: 100%; margin-top: 30px">
      <div ref="lineEchart" class="myEchart" style="height: 500px"></div>
      <a-table
        style="margin-left: 50px"
        :columns="columns"
        :data-source="tableData"
        :pagination="{ pageSize: 10 }"
      >
        <a slot="name" slot-scope="text">{{ text }}</a>
      </a-table>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
// import * as d3 from 'd3';
// const projection = d3.geoNaturalEarth1();
import mapData from '@/utils/world.json';
import { getVirtualHoleByLatLon } from '@/api/index';
echarts.registerMap('myworld', mapData);

const columns = [
  {
    title: 'Age(Ma)',
    dataIndex: 'age',
    key: 'age',
    width: '50%',
    align: 'center',
  },
  {
    title: 'Depth(m)',
    dataIndex: 'predict_depth',
    key: 'predict_depth',
    width: '50%',
    align: 'center',
  },
];
export default {
  name: 'virtualdrillingName',
  mounted() {
    // const Hole = this.$route.query.Holevalue;
    // getBchronPangaea(Hole).then((res) => {
    //   this.data = res;
    //   res.map((item) => {
    //     console.log(item);
    //   });
    // });
    this.initEcharts();
    this.changeOption();
  },
  data() {
    return {
      columns: columns,
      pointData: [],
      tableData: [],
      currentPoint: [0, 0],
    };
  },
  methods: {
    initEcharts() {
      this.mychartMap = echarts.init(this.$refs.myEchart);
      let series = [];
      let option = {
        backgroundColor: '',
        // backgroundColor: 'gray',
        tooltip: {
          trigger: 'axis',
        },

        legend: {
          show: false,
          bottom: 150,
          width: 300,
          height: 200,
          textStyle: {
            fontSize: 20,
          },
        },
        // xAxis: {
        //   axisPointer: {
        //     show: true, // 显示坐标轴指示器，包括经纬线
        //   },
        //   splitLine: {
        //     //x网格样式
        //     show: true,
        //     lineStyle: {
        //       color: 'rgba(0, 255, 255, 1)',
        //       type: 'solid',
        //       width: '3',
        //     },
        //   },
        //   axisLine: {
        //     //x坐标轴样式
        //     lineStyle: {
        //       type: 'solid',
        //       color: '#657CA8', //左边线的颜色
        //       width: '2', //坐标线的宽度
        //     },
        //   },
        //   axisLabel: {
        //     textStyle: {
        //       color: 'white',
        //     },
        //   },
        // },
        // yAxis: {
        //   axisPointer: {
        //     show: true, // 显示坐标轴指示器，包括经纬线
        //   },
        // },
        geo: {
          map: 'myworld',

          // roam: true,
          // roam: true,
          zoom: 1.1,
          label: {
            emphasis: {
              show: false,
            },
          },

          // projection: {
          //   project: (point) => projection(point),
          //   unproject: (point) => projection.invert(point),
          // },
          // silent: true,
          itemStyle: {
            // areaColor: '#004981', //地图颜色
            areaColor: 'rgba(106, 104, 104, 0.34)',
            color: '#000',
            // areaColor: '#a9a9f6',
            // areaColor: "black",
            borderColor: 'white',
            borderWidth: 0,

            emphasis: {
              areaColor: 'rgba(106, 104, 104, 0.34)',
            },
          },
        },

        series: series,
      };

      if (option && typeof option === 'object') {
        this.mychartMap.setOption(option, true);
        console.log(this.mychartMap.getOption());
      }
      window.onresize = this.mychartMap.resize;

      this.mychartMap.getZr().on('click', async (e) => {
        console.log(e);
        const res = await getVirtualHoleByLatLon(
          this.mychartMap.convertFromPixel('geo', [
            e.event.offsetX,
            e.event.offsetY,
          ])
        );

        this.currentPoint = this.mychartMap.convertFromPixel('geo', [
          e.event.offsetX,
          e.event.offsetY,
        ]);
        this.mychartMap.setOption(
          {
            series: {
              coordinateSystem: 'geo',
              type: 'scatter',
              symbolSize: 7,
              itemStyle: {
                color: '#ff0000',
              },
              data: [this.currentPoint],
            },
          },
          false
        );
        this.pointData = [];
        res.map((item) => {
          this.pointData.push([item.age, item.predict_depth]);
        });
        this.changeOption();
        this.tableData = res;
        console.log(res);
      });
      this.lineEchart = echarts.init(this.$refs.lineEchart);
    },
    async getData() {
      console.log('this.currentPoint', this.currentPoint);
      const res = await getVirtualHoleByLatLon(this.currentPoint);
      this.mychartMap.setOption(
        {
          series: {
            coordinateSystem: 'geo',
            type: 'scatter',
            symbolSize: 7,
            itemStyle: {
              color: '#ff0000',
            },
            data: [this.currentPoint],
          },
        },
        false
      );
      this.pointData = [];
      res.map((item) => {
        this.pointData.push([item.age, item.predict_depth]);
      });
      this.changeOption();
      this.tableData = res;
      console.log(res);
      this.lineEchart = echarts.init(this.$refs.lineEchart);
    },
    changeOption() {
      let option = {
        xAxis: {
          position: 'top',
          name: 'Age(Ma)',
          nameLocation: 'center',
          nameTextStyle: {
            padding: 5,
            fontSize: 15,
          },
        },
        yAxis: {
          inverse: true,
          name: 'Depth(m)',
          nameTextStyle: {
            padding: 5,
            fontSize: 15,
          },
        },
        series: [
          {
            symbolSize: 10,
            itemStyle: {
              color: 'skyblue',
              borderColor: '#555',
            },
            data: this.pointData,
            type: 'scatter',
          },
        ],
      };
      console.log(this.pointData);
      this.lineEchart.setOption(option);
    },
  },
};
</script>

<style>
.container {
  display: flex;
  justify-content: space-around;
  height: 100%;
}
</style>
